import * as React from "react";
import styled, { css } from "styled-components";

import { colors } from "../../../common/utils/style";

interface Props {
  sectionId: string;
  displayName: string;
  active: boolean;
  activeColor: string;
  onClick: (sectionId: string) => void;
}

class SectionAsideNavItem extends React.PureComponent<Props> {
  public onClick = (e: React.MouseEvent<HTMLElement>) => {
    const { sectionId, onClick } = this.props;
    e.preventDefault();
    onClick(sectionId);
  };

  public render() {
    const { sectionId, displayName, active, activeColor } = this.props;
    return (
      <NavItemBase
        key={sectionId}
        href={`#${sectionId}`}
        active={active}
        activeColor={activeColor}
        onClick={this.onClick}
      >
        {displayName}
      </NavItemBase>
    );
  }
}

interface NavItemStyleProps {
  active: boolean;
  activeColor: string;
}

const NavItemBase = styled.a`
  display: block;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.27);
  margin-bottom: 3px;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: ${colors.gray4};
  }
  &:last-child {
    margin-bottom: 0;
  }
  ${(props: NavItemStyleProps) =>
    props.active
      ? css`
          font-weight: 500;
          color: ${colors.gray4};
          &:before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            background-color: ${props.activeColor};
            border-radius: 50%;
            margin-right: 6px;
          }
        `
      : ""};
`;

export default SectionAsideNavItem;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/molecules/SectionAsideNavItem.tsx